import React from 'react';
import { useLanguage } from './i18n/useLanguage';
import { getAboutText } from './i18n/about/getAbout';
import { landingCopy } from './i18n/landing';
import { legalCopy } from './i18n/legal';
import PageMetadata from './PageMetadata';
import SectionLabel from './SectionLabel';
import { SiteHeader, SiteFooter, IconSprite, Icon, Arrow } from './SiteChrome';
import logo from './layout-assets/logo.svg';
import './LegalPages.css';

export default function About() {
  const [language, changeLanguage] = useLanguage();
  const a = key => getAboutText(key, language);
  const copy = legalCopy(language);
  const landing = landingCopy(language);
  return <div className="plannely-layout">
    <PageMetadata language={language} title={a('about.meta.title')} description={a('about.meta.description')} url="https://plannely.app/about" />
    <IconSprite />
    <div className="wrap" id="top">
      <SiteHeader language={language} onLanguageChange={changeLanguage} />
      <main className="legal-main">
        <header className="about-intro">
          <div><SectionLabel>Plannely · SEOTIV</SectionLabel><h1>{a('about.header.title')}</h1><p>{a('about.p1')}</p></div>
          <div className="about-art" aria-hidden="true">
            <div className="brand"><img src={logo} width="100" height="100" alt="" />Plannely</div>
            <p>{landing.footer}</p>
            <div className="about-art-icons">{['list', 'repeat', 'focus'].map(name => <span key={name}><Icon name={name} /></span>)}</div>
          </div>
        </header>
        <div className="about-values">
          {[['focus', copy.purpose, 'about.p2'], ['list', copy.products, 'about.p3'], ['check', copy.privacy, 'about.p4']].map(([icon, title, key]) => <section className="about-value" key={key}><Icon name={icon} /><h2>{title}</h2><p>{a(key)}</p></section>)}
        </div>
        <section className="about-belief"><p>{a('about.p5')}</p></section>
        <section className="about-contact">
          <div><p>{a('about.website.label')}</p><strong>SEOTIV</strong></div>
          <a className="btn" href="https://seotiv.com" target="_blank" rel="noopener noreferrer">seotiv.com<Arrow /></a>
        </section>
        <a className="legal-back" href="/"><Arrow />{copy.back}</a>
      </main>
      <SiteFooter language={language} currentPage="about" />
    </div>
  </div>;
}
